import { useState } from "react";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { Button, Icon } from "react-bulma-components";
import { useTranslation } from "react-i18next";
import { fbAuth } from "../../firebase";

type SignInWithGoogleButtonProps = { initializing: boolean }

const googleProvider = new GoogleAuthProvider();

export const SignInWithGoogleButton = ({ ...props }: SignInWithGoogleButtonProps) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  return (
    <Button
      color="info"
      loading={props.initializing || loading}
      disabled={props.initializing || loading}
      onClick={() => {
        setLoading(true);
        signInWithPopup(fbAuth, googleProvider)
          .catch((e) => console.error(e))
          .finally(() => setLoading(false));
      }}>
      <Icon>
        <i className="icon-login" aria-hidden="true"></i>
      </Icon>
      <span>{t("sign-in.google")}</span>
    </Button>
  )
}
